export const API_ROOT = process.env['VUE_APP_API_ROOT'] ?? '';
export const TITLE_SUFFIX = process.env['VUE_APP_TITLE_SUFFIX'] ?? '';
